import { useI18n } from "@/app/composables/useI18n"
import { computed } from "vue"

export function useCategoryTranslation() {
  const { locale, t } = useI18n()

  const getCategoryName = computed(() => {
    return (category: any) => {
      if (!category)
        return ""

      if (category.slug === "home") {
        return t("casino.home")
      }

      if (category.slug === "providers") {
        return t("casino.providers")
      }

      const currentLangCode = locale.value?.code

      if (category.translations && currentLangCode && category.translations[currentLangCode]) {
        return category.translations[currentLangCode].name
      }

      return category.name
    }
  })

  return {
    getCategoryName,
  }
}
